import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link, useNavigate} from "react-router-dom";
import {Modal} from "../components/Modal";
import {useState} from "react";
import {IoMdClose} from "react-icons/io"; // Import close icon

const Notice_Board = () => {
    const navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    const banners = [
        {
            img: "/landingPage_banner/step1-joglekarkul-videotutorial.png",
            url: "/video_tutorial",
        },
        {
            img: "/landingPage_banner/step2-joglekarkul-register.png",
            url: "/register"
        },
        {img: "/landingPage_banner/step3-event2.png"},
        {img: "/landingPage_banner/step4-event1.png"},
        {img: "/landingPage_banner/event03.png"},
    ];

    const ytButton = [
        {
            id: 1,
            title: "ध्येय",
            img: "/kulvratant_landingPage/video-thumbnail.png",
            videoUrl: "https://www.youtube.com/embed/zcyPAA-wdyA", // Embed URL
        },
        {
            id: 2,
            title: "हितगुज",
            img: "/kulvratant_landingPage/video-thumbnail.png",
            videoUrl: "https://www.youtube.com/embed/I7WRmX7Ku-4",
        },
        {
            id: 3,
            title: "एकमेका सहाय्य करू, एक विचार",
            img: "/kulvratant_landingPage/video-thumbnail.png",
            videoUrl: "https://www.youtube.com/embed/qpXoQyH5reM",
        },
    ];

    const openModal = (url, title) => {
        if (url) {
            setVideoUrl(url);
            setModalTitle(title);
            setModalOpen(true);
        } else {
            alert("Video not available");
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setVideoUrl("");
        setModalTitle("");
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
    };

    return (
        <div
            className="relative w-full flex max-h-fit h-fit min-h-fit"
        >
            {/* Noticeboard Image */}
            <div
                className="absolute w-full h-full border-[1rem] border-[#DDB36B]
                    bg-[radial-gradient(80.5%_294.93%_at_50%_23.23%,_#FAFAFA_0%,_#FADA48_61.29%,_#FBDA3D_100%)]"
            >
                <div
                    className="absolute w-full h-full border-[1rem] border-[#A36025]
                    bg-[radial-gradient(80.5%_294.93%_at_50%_23.23%,_#FAFAFA_0%,_#FADA48_61.29%,_#FBDA3D_100%)]"
                >
                    {/* Pins */}
                    <img
                        src="/assets/notice-board-pin-left.svg"
                        alt="Pin Left"
                        className="md:w-10 w-[2rem] absolute -top-2 md:top-1 -left-2 md:left-1"
                    />

                    <img
                        src="/assets/notice-board-pin-right.svg"
                        alt="Pin Right"
                        className="md:w-10 w-[2rem] absolute -top-2 md:top-1 -right-2 md:right-1"
                    />
                </div>
            </div>

            {/* Container for Slider & Buttons */}
            <div className="py-10 px-10 z-50 w-full h-full flex flex-col gap-y-2">
                {/* Image Slider */}
                <h1 className={"text-center w-full font-custom-mono-bold portrait:text-[1.75rem] landscape:text-[2rem]"}>
                    NOTICE BOARD
                </h1>
                <div className="flex portrait:flex-col gap-3 mx-auto w-full justify-between">
                    <div className="portrait:mt-4 landscape:w-2/3 portrait:w-full h-full">
                        <Slider {...settings}>
                            {banners.map((banner, index) => (
                                <Link to={banner.url} className={"h-full w-full aspect-auto"}>
                                    <div key={index}>
                                        <img
                                            src={banner.img}
                                            className="portrait:h-1/2 rounded-md shadow-md"
                                            alt={`Slide ${index + 1}`}
                                        />
                                    </div>
                                </Link>
                            ))}
                        </Slider>
                    </div>

                    {/* YouTube Button Links (Placed on the right) */}
                    <div className="lg:w-1/3 z-30 w-full flex flex-col justify-between portrait:gap-4">
                        {ytButton.map((btn) => (
                            <div className="">
                                <button
                                    key={btn.id}
                                    onClick={() => openModal(btn.videoUrl, btn.title)}
                                    rel="noopener noreferrer"
                                    className="w-full px-10 py-5 text-white text-xl sm:text-2xl font-bold rounded-xl
                                        bg-gradient-to-b from-yellow-400 via-orange-400 to-red-600 shadow-lg
                                        border-[3px] border-black text-center"
                                >
                                    {btn.title}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Modal */}
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="relative w-full h-full p-4 sm:p-6 bg-white rounded-lg">
                    <button
                        className="absolute top-2 right-2 text-gray-700 rounded-full p-2 shadow-md"
                        onClick={closeModal}
                    >
                        <IoMdClose/>
                    </button>
                    <h2 className="text-center text-xl sm:text-2xl font-bold text-red-600 mb-4">
                        {modalTitle}
                    </h2>
                    {videoUrl ? (
                        <iframe
                            width="100%"
                            height="250"
                            className="sm:h-[350px] rounded-lg"
                            src={videoUrl}
                            title="YouTube video"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <div className="text-center text-lg font-semibold">
                            Video not available
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default Notice_Board;
